export const SET_PLUGIN_UTILS = 'SET_PLUGIN_UTILS';

/**
 * Sets map choropleth action callback and other utils
 */
export const setChoroplethUtils = (data) => ({
  type: SET_PLUGIN_UTILS,
  payload: data,
});